import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Pencil = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 100 100"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.79 29.297L70.702 11.209a2.692 2.692 0 00-3.808 0L17.389 60.713l.109.109-.171-.046-6.772 25.272.004.001a2.681 2.681 0 00.642 2.748 2.684 2.684 0 003.033.531l.002.009 25.027-6.706-.016-.059.038.038L88.79 33.105a2.692 2.692 0 000-3.808zm-69.998 51.85l4.022-15.009 10.988 10.988-15.01 4.021z"
  }));
});
Pencil.displayName = 'Pencil';
export var PencilDimensions = {
  height: 100,
  width: 100
};